import { WebsiteContentBlock } from '../content/website-content';

export function WebsiteDocument({ blocks, headingLevel = 'h3' }: { blocks: WebsiteContentBlock[]; headingLevel?: 'h2' | 'h3' }) {
    const Heading = headingLevel;
    return <>{blocks.map((block, index) => block.type === 'heading' ? <Heading key={index}>{block.text}</Heading>
        : block.type === 'list' ? <ul key={index} className="line-height-3">{block.items.map(item => <li key={item}>{item}</li>)}</ul>
        : <p key={index} className="line-height-3">{block.text}</p>)}</>;
}
